import {LocationInterface, PlaceholderLocationInterface} from "@/types/Location";

export class PlaceholderLocation implements PlaceholderLocationInterface {
  entityId?: number;
  id?: string;
  name?: string;
  street?: string;
  streetNr?: string;
  areacode?: string;
  city?: string;
  country?: string;
  description?: string;


  constructor({entityId, id, name, street, streetNr, areacode, city, country, description}: PlaceholderLocationInterface = {}) {
    this.entityId = entityId;
    this.id = id;
    this.name = name;
    this.street = street;
    this.streetNr = streetNr;
    this.areacode = areacode;
    this.city = city;
    this.country = country;
    this.description = description;
  }
}

export class Location extends PlaceholderLocation implements LocationInterface{
  entityId: number;
  id!: string;
  name!: string;
  street!: string;
  streetNr!: string;
  areacode!: string;
  city!: string;
  country!: string;
  description!: string;


  constructor({entityId, id, name, street, streetNr, areacode, city, country, description}: LocationInterface) {
    super({entityId, id, name, street, streetNr, areacode, city, country, description});
    this.entityId = entityId;
    this.id = id;
    this.name = name;
    this.street = street;
    this.streetNr = streetNr;
    this.areacode = areacode;
    this.city = city;
    this.country = country;
    this.description = description;
  }
}
